import { useQuery } from '@tanstack/react-query';
import { Spinner } from '@telegram-apps/telegram-ui';
import { useState } from 'react';
import {
  SORT_LABELS,
  STATUS_LABELS,
  type MediaType,
  type SortOption,
  type Status,
} from '@mass-cult/shared';
import { EmptyState, ErrorState, TitleListItem } from '../../components/ui';
import { getLibrary } from '../../shared/api/client';

const TABS: Status[] = ['plan', 'watching', 'watched'];

export function LibraryPage() {
  const [status, setStatus] = useState<Status>('plan');
  const [type, setType] = useState<MediaType | 'all'>('all');
  const [sort, setSort] = useState<SortOption>('added_desc');

  const libraryQuery = useQuery({
    queryKey: ['library', status, type, sort],
    queryFn: () =>
      getLibrary({
        status,
        type: type === 'all' ? undefined : type,
        sort,
      }),
  });

  return (
    <div>
      <h1>Мои списки</h1>

      <div className="chips">
        {TABS.map((tab) => (
          <button
            key={tab}
            className={`chip ${status === tab ? 'active' : ''}`}
            onClick={() => setStatus(tab)}
          >
            {STATUS_LABELS[tab]}
          </button>
        ))}
      </div>

      <div className="toolbar">
        <select value={type} onChange={(event) => setType(event.target.value as MediaType | 'all')}>
          <option value="all">Все типы</option>
          <option value="movie">Фильмы</option>
          <option value="tv">Сериалы</option>
        </select>
        <select value={sort} onChange={(event) => setSort(event.target.value as SortOption)}>
          {Object.entries(SORT_LABELS).map(([value, label]) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </div>

      {libraryQuery.isLoading && <Spinner size="m" />}
      {libraryQuery.isError && (
        <ErrorState message={(libraryQuery.error as Error).message} />
      )}
      {!libraryQuery.isLoading && libraryQuery.data?.length === 0 && (
        <EmptyState title="Список пуст" />
      )}

      {libraryQuery.data?.map((item) => (
        <TitleListItem
          key={`${item.mediaType}-${item.tmdbId}`}
          mediaType={item.mediaType}
          tmdbId={item.tmdbId}
          title={item.title}
          subtitle={[item.year, item.rating ? `Моя оценка ${item.rating}` : null]
            .filter(Boolean)
            .join(' · ')}
          posterUrl={item.posterUrl}
          rating={item.rating}
          status={item.status}
        />
      ))}
    </div>
  );
}
